import React from 'react';
import { Grid, Skeleton } from '@mui/material';

export const AccountProfessionalDetailsFormSkeleton = () => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
                <Grid size={12}>
                    <Skeleton height={50} />
                </Grid>
            </Grid>
            <Grid
                container
                sx={{
                    justifyContent: 'flex-end',
                    marginTop: 2,
                }}
            >
                <Skeleton height={50} width={80} />
            </Grid>
        </>
    );
};
